// extracted by mini-css-extract-plugin
export default {"productCarousel":"GY-z"};